/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import DosageGuideline from './dosage-guideline';
import DosageGuidelineDetail from './dosage-guideline-detail';
import DosageGuidelineUpdate from './dosage-guideline-update';
import DosageGuidelineDeleteDialog from './dosage-guideline-delete-dialog';

const DosageGuidelineRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<DosageGuideline />} />
    <Route path="new" element={<DosageGuidelineUpdate />} />
    <Route path=":id">
      <Route index element={<DosageGuidelineDetail />} />
      <Route path="edit" element={<DosageGuidelineUpdate />} />
      <Route path="delete" element={<DosageGuidelineDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default DosageGuidelineRoutes;
